﻿(function(){
  const TAB_HIDDEN_CLASS = 'dpo-tab-hidden'
  const TABBAR_CLASS = 'dpo-tabs__bar'
  const TABBTN_CLASS = 'dpo-tabs__btn'
  const TABBTN_ACTIVE = 'dpo-tabs__btn--active'
  const PANEL_HIDDEN_CLASS = 'dpo-accordion__panel--hidden'
  const ACCORDION_CLASS = 'dpo-accordion'
  const ITEM_CLASS = 'dpo-accordion__item'
  const HEADER_CLASS = 'dpo-accordion__header'
  const PANEL_CLASS = 'dpo-accordion__panel'
  const SINGLE_OPEN = true // set to false to allow multiple open panels
  const SHOW_ALL_SECTIONS = false 
  const MOBILE_BREAKPOINT = 750
  const OFFSCREEN_HIDDEN_CLASS = PANEL_HIDDEN_CLASS // alias for clarity
  const STATE_CORRECT = 'Correct'
  const STATE_ERROR = 'error'
  const ITEM_DPO_HIDDEN_CLASS = 'dpo-accordion__item--dpo-hidden'
  const TAB_DPO_HIDDEN_CLASS = 'dpo-tabs__btn--dpo-hidden'

  function createStateIndicator() {
    const wrap = document.createElement('div')
    wrap.className = 'dpo-state-indicator'
    wrap.setAttribute('aria-hidden', 'true')
    return wrap
  }

  function updateStateIndicator(el, state) {
    const wrap = el && el.querySelector && el.querySelector('.dpo-state-indicator')
    if (!wrap) return
    const currentState = wrap.getAttribute('data-dpo-state') || ''
    const newState = state || ''
    if (currentState === newState) return
    wrap.setAttribute('data-dpo-state', newState)
    if (el) {
      el.removeAttribute('data-state')
      if (state) el.setAttribute('data-state', state)
    }
    wrap.removeAttribute('data-state')
    wrap.classList.remove('dpo-state-indicator--hidden')
    wrap.innerHTML = ''
    if (!state) {
      wrap.classList.add('dpo-state-indicator--hidden')
    } else if (state === STATE_CORRECT) {
      wrap.setAttribute('data-state', STATE_CORRECT)
      wrap.innerHTML = '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5L5 9L13 1" stroke="#59CD90" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    } else if (state === STATE_ERROR) {
      wrap.setAttribute('data-state', STATE_ERROR)
      const dot = document.createElement('div')
      dot.className = 'dpo-state-indicator__dot'
      wrap.appendChild(dot)
    }
  }

  function ensureClosedSet(root) {
    if (!root.__dpoClosedSections) root.__dpoClosedSections = new Set()
    return root.__dpoClosedSections
  }

  function markSectionClosed(root, index) {
    ensureClosedSet(root).add(index)
  }

  function shouldShowSectionErrorIndicator(container, collapsed, sectionIndex, closedSet) {
    if (!container) return false
    if (sectionHasVisibleValidationDom(container)) return true
    return !!(collapsed && closedSet.has(sectionIndex) && sectionHasHeuristicValidationIssue(container))
  }

  function updateSectionStates(root) {
    if (!root) return
    const isAccordion = !!root.__dpoAccordion
    const isTabs = !!root.__dpoTabbed
    const closedSet = ensureClosedSet(root)
    const getContainerForTabBtn = (btn) => {
      const id = btn.getAttribute('aria-controls')
      return id ? root.querySelector('#' + CSS.escape(id)) : null
    }
    const isCollapsed = (btn, isTab) => {
      if (isTab) {
        const active = btn.classList.contains(TABBTN_ACTIVE)
        return !active
      }
      return btn.getAttribute('aria-expanded') !== 'true'
    }
    if (isTabs) {
      const bar = root.querySelector('.dpo-tabs__bar')
      if (!bar) return
      Array.from(bar.children).forEach((btn, idx) => {
        const cont = getContainerForTabBtn(btn)
        const collapsed = isCollapsed(btn, true)
        if (shouldShowSectionErrorIndicator(cont, collapsed, idx, closedSet)) {
          updateStateIndicator(btn, STATE_ERROR)
          return
        }
        const showCheckmark = collapsed && closedSet.has(idx)
        updateStateIndicator(btn, showCheckmark ? STATE_CORRECT : null)
      })
    } else if (isAccordion) {
      const items = root.querySelectorAll('.dpo-accordion__item')
      items.forEach((item, idx) => {
        const btn = item.querySelector('.dpo-accordion__header')
        const panel = item.querySelector('.dpo-accordion__panel')
        const collapsed = btn && isCollapsed(btn, false)
        if (shouldShowSectionErrorIndicator(panel, collapsed, idx, closedSet)) {
          if (btn) updateStateIndicator(btn, STATE_ERROR)
          return
        }
        const showCheckmark = collapsed && closedSet.has(idx)
        if (btn) updateStateIndicator(btn, showCheckmark ? STATE_CORRECT : null)
      })
    }
  }

  function triggerFieldValidationInPanel(panel) {
    if (!panel) return
    try {
      const list = panel.querySelectorAll('input, select, textarea')
      for (let i = 0; i < list.length; i++) {
        const el = list[i]
        if (el.type === 'hidden' || el.disabled) continue
        el.dispatchEvent(new Event('blur', { bubbles: true }))
        el.dispatchEvent(new Event('focusout', { bubbles: true }))
      }
      if (window.jQuery) {
        window.jQuery(panel).find('input, select, textarea').trigger('blur')
      }
    } catch (e) {}
    runDpoFieldValidationInPanel(panel)
  }

  function controlHasValidationRules(control, fieldEl) {
    if (!control) return false
    const validationAttr = String(control.getAttribute('validation') || '').trim()
    if (validationAttr) return true
    const dataValidate = String(control.getAttribute('data-validate') || '').trim()
    if (dataValidate) return true
    if (control.hasAttribute('pattern')) return true
    if (control.hasAttribute('min') || control.hasAttribute('max')) return true
    return controlIsRequired(control, fieldEl)
  }

  function runDpoFieldValidationInPanel(panel) {
    if (!panel || !window.dpoValidation || typeof window.dpoValidation.validateField !== 'function') return
    try {
      panel.querySelectorAll('.validation-advice').forEach((node) => node.remove())
      panel.querySelectorAll('.dpo-error').forEach((node) => node.classList.remove('dpo-error'))

      const controls = panel.querySelectorAll('input, select, textarea')
      for (let i = 0; i < controls.length; i++) {
        const control = controls[i]
        if (!control || control.disabled || control.type === 'hidden') continue
        if (!isDpoOptionControl(control)) continue
        const field = dpoFieldWrapperFor(control)
        if (field && isFieldEffectivelyHidden(field, panel)) continue
        if (!controlHasValidationRules(control, field)) continue
        window.dpoValidation.validateField(control)
      }
    } catch (e) {}
  }

  function scheduleSectionValidationAfterClose(root, panel) {
    if (!root || !panel) return
    triggerFieldValidationInPanel(panel)
    try {
      document.dispatchEvent(new CustomEvent('dpo-update-section-states', { bubbles: true }))
    } catch (e) {}
    updateSectionStates(root)
    setTimeout(function () {
      updateSectionStates(root)
    }, 180)
  }

  function sectionHasNativeInvalidControls(container) {
    if (!container) return false
    try {
      const controls = container.querySelectorAll('input, select, textarea')
      for (let i = 0; i < controls.length; i++) {
        const el = controls[i]
        if (!el || el.disabled || el.type === 'hidden') continue
        if (typeof el.checkValidity === 'function' && !el.checkValidity()) return true
      }
    } catch (e) {}
    return false
  }

  function setupStateObserver(root) {
    if (!root || root.__dpoStateObserved) return
    let debounceTimer
    const scheduleUpdate = () => {
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => updateSectionStates(root), 100)
    }
    const observer = new MutationObserver(scheduleUpdate)
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-expanded'] })
    root.addEventListener('input', scheduleUpdate, { passive: true })
    root.addEventListener('change', scheduleUpdate, { passive: true })
    root.__dpoStateObserved = true
  }

  function isHiddenTitle(title){
    const t = String(title || '').trim().toLowerCase()
    return /\(hidden\)/i.test(t) || t.endsWith(' hidden') || t.includes('[hidden]')
  }

  function hardHideSection(headerEl, containerEl){
    try {
      if (headerEl) headerEl.style.display = 'none'
      if (containerEl) {
        containerEl.classList.add(TAB_HIDDEN_CLASS, PANEL_HIDDEN_CLASS)
        containerEl.setAttribute('hidden','')
        containerEl.setAttribute('aria-hidden','true')
        containerEl.style.display = 'none'
      }
    } catch(e){}
  }

  function isMobile(){
    return window.innerWidth < MOBILE_BREAKPOINT
  }

  function scrollAccordionItemIntoView(itemEl) {
    if (!itemEl || isMobile()) return
    try {
      const header =
        document.querySelector('.shopify-section-group-header-group .section-header') ||
        document.querySelector('.shopify-section-header-sticky') ||
        document.querySelector('.section-header') ||
        document.querySelector('header')
      const headerHeight = header ? Math.max(header.getBoundingClientRect().height || 0, 0) : 0
      const topPadding = 16
      const absoluteTop = itemEl.getBoundingClientRect().top + window.pageYOffset
      const targetTop = Math.max(absoluteTop - headerHeight - topPadding, 0)
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      })
    } catch (e) {}
  }

  function titleToKey(title){
    const t = String(title || '').toLowerCase()
    if (t.includes('cabinet size') || t.includes('size')) return 'cabinetDimensions'
    if (t.includes('door configuration') || t.includes('doors')) return 'doorConstruction'
    if (t.includes('materials') || t.includes('finish')) return 'materials'
    if (t.includes('mounting') || t.includes('base')) return 'typeOfBase'
    if (t.includes('handles')) return 'handles'
    if (t.includes('countertop')) return 'counterTop'
    if (t.includes('customisation') || t.includes('customization')) return 'modifications'
    if (t.includes('additional')) return 'additional'
    return t.replace(/\s+/g,'_') || 'section'
  }

  function elementIsDpoHidden(el) {
    if (!el || !(el instanceof Element)) return false
    if (el.hidden) return true
    if (el.classList.contains('ihidden')) return true
    if (el.classList.contains('hidden')) return true
    const attrStyle = el.getAttribute('style') || ''
    if (/display\s*:\s*none/i.test(attrStyle)) return true
    if (/visibility\s*:\s*hidden/i.test(attrStyle)) return true
    try {
      const style = window.getComputedStyle(el)
      if (style.display === 'none') return true
      if (style.visibility === 'hidden') return true
    } catch (e) {}
    return false
  }

  function getSectionOrder(container) {
    if (!container) return null
    const id = container.id || ''
    const match = id.match(/fieldset-section-(\d+)/)
    if (match) return parseInt(match[1], 10)
    return null
  }

  function readBalancedChunk(text, startIdx, openChar, closeChar) {
    if (!text || startIdx < 0 || text[startIdx] !== openChar) return ''
    let depth = 0
    let inString = false
    let stringQuote = ''
    let escaped = false
    for (let i = startIdx; i < text.length; i++) {
      const ch = text[i]
      if (inString) {
        if (escaped) {
          escaped = false
        } else if (ch === '\\') {
          escaped = true
        } else if (ch === stringQuote) {
          inString = false
          stringQuote = ''
        }
        continue
      }
      if (ch === '"' || ch === "'") {
        inString = true
        stringQuote = ch
        continue
      }
      if (ch === openChar) depth += 1
      if (ch === closeChar) depth -= 1
      if (depth === 0) return text.slice(startIdx, i + 1)
    }
    return ''
  }

  function parseDpoInitializePayload() {
    try {
      if (window.__dpoTabsInitializePayload) return window.__dpoTabsInitializePayload
      const scripts = Array.from(document.querySelectorAll('script'))
      for (let i = 0; i < scripts.length; i++) {
        const content = scripts[i] && scripts[i].textContent
        if (!content || content.indexOf('window.dpoOptions.initialize(') === -1) continue
        const marker = content.indexOf('window.dpoOptions.initialize(')
        const afterMarker = marker + 'window.dpoOptions.initialize('.length
        const firstObjectStart = content.indexOf('{', afterMarker)
        const configChunk = readBalancedChunk(content, firstObjectStart, '{', '}')
        if (!configChunk) continue
        const optionsStart = content.indexOf('[', firstObjectStart + configChunk.length)
        const optionsChunk = readBalancedChunk(content, optionsStart, '[', ']')
        const config = JSON.parse(configChunk)
        const options = JSON.parse(optionsChunk)
        const payload = {
          config,
          options
        }
        window.__dpoTabsInitializePayload = payload
        return payload
      }
    } catch (e) {}
    return null
  }

  function getDpoSectionConfig() {
    const payload = parseDpoInitializePayload()
    if (!payload) return null
    const config = payload.config || {}
    const options = Array.isArray(payload.options) ? payload.options : []
    const sectionConditions = Array.isArray(config.section_conditions) ? config.section_conditions : []
    if (!sectionConditions.length || !options.length) return null
    return {
      sectionConditions,
      options
    }
  }

  function getOptionSelectedTitles(optionConfig) {
    if (!optionConfig || !optionConfig.option_id) return []
    const root = document.getElementById('itoris_dynamicproductoptions') || document
    const type = String(optionConfig.type || '').toLowerCase()
    const inputName = `options[${optionConfig.option_id}]`
    const inputNameArray = `${inputName}[]`
    const titleByValue = new Map()
    const items = Array.isArray(optionConfig.items) ? optionConfig.items : []
    items.forEach((item) => {
      if (!item) return
      titleByValue.set(String(item.option_type_id), item.title)
      titleByValue.set(String(item.title), item.title)
    })

    if (type === 'checkbox' || type === 'multiple') {
      const checked = Array.from(root.querySelectorAll(`input[name="${inputNameArray}"]:checked, input[name="${inputName}"]:checked`))
      return checked
        .map((input) => titleByValue.get(String(input.value)) || input.value || '')
        .filter(Boolean)
    }

    if (type === 'radio') {
      const checked = root.querySelector(`input[name="${inputName}"]:checked`)
      if (!checked) return []
      const value = String(checked.value || '')
      if (!value) return ['None']
      return [titleByValue.get(value) || value]
    }

    if (type === 'drop_down') {
      const select = root.querySelector(`select[name="${inputName}"]`)
      if (!select) return []
      const selected = Array.from(select.selectedOptions || [])
      return selected
        .map((opt) => titleByValue.get(String(opt.value)) || opt.textContent || opt.value || '')
        .map((v) => String(v).trim())
        .filter(Boolean)
    }

    if (type === 'field' || type === 'area' || type === 'file' || type === 'slider') {
      const input = root.querySelector(`[name="${inputName}"]`)
      if (!input || typeof input.value === 'undefined') return []
      const value = String(input.value || '').trim()
      return value ? [value] : []
    }

    return []
  }

  function buildDpoValueMap() {
    const cfg = getDpoSectionConfig()
    if (!cfg) return null
    const valueMap = new Map()
    cfg.options.forEach((option) => {
      if (!option || !option.internal_id) return
      valueMap.set(String(option.internal_id), getOptionSelectedTitles(option))
    })
    return valueMap
  }

  function evaluateDpoConditionNode(node, valueMap) {
    if (!node) return true
    const type = String(node.type || '').toLowerCase()
    const conditions = Array.isArray(node.conditions) ? node.conditions : []
    if (type === 'all') return conditions.every((child) => evaluateDpoConditionNode(child, valueMap))
    if (type === 'any') return conditions.some((child) => evaluateDpoConditionNode(child, valueMap))
    if (type === 'field') {
      const actualValues = valueMap && valueMap.get(String(node.field)) || []
      const expected = String(node.value || '').trim()
      const mode = String(node.condition || 'is').toLowerCase()
      const hasMatch = actualValues.some((value) => String(value).trim() === expected)
      if (mode === 'is_not') return !hasMatch
      return hasMatch
    }
    return true
  }

  function sectionShouldBeVisibleByConfig(container) {
    if (!isMobile()) return null
    const sectionOrder = getSectionOrder(container)
    if (!sectionOrder) return null
    const cfg = getDpoSectionConfig()
    if (!cfg) return null
    const sectionConfig = cfg.sectionConditions.find((item) => Number(item.order) === Number(sectionOrder))
    if (!sectionConfig) return null
    const valueMap = buildDpoValueMap()
    if (!valueMap) return null
    let conditionMet = true
    const rawCondition = sectionConfig.visibility_condition
    if (rawCondition) {
      try {
        conditionMet = evaluateDpoConditionNode(JSON.parse(rawCondition), valueMap)
      } catch (e) {
        conditionMet = true
      }
    }
    const baseVisibility = String(sectionConfig.visibility || '').toLowerCase()
    const action = String(sectionConfig.visibility_action || '').toLowerCase()
    let shouldBeVisible = baseVisibility !== 'hidden'
    if (action === 'hidden' && conditionMet) shouldBeVisible = false
    if (action === 'visible' && conditionMet) shouldBeVisible = true
    return shouldBeVisible
  }

  function isFieldEffectivelyHidden(field, sectionContainer) {
    if (!field) return true
    if (elementIsDpoHidden(field)) return true
    let node = field.parentElement
    while (node && node !== sectionContainer) {
      if (elementIsDpoHidden(node)) return true
      node = node.parentElement
    }
    const tr = field.closest('tr.fields')
    if (tr && tr !== sectionContainer && elementIsDpoHidden(tr)) return true
    return false
  }

  function dpoFieldWrapperFor(control) {
    return (
      control &&
      (control.closest('.field') ||
        control.closest('tr.fields') ||
        control.closest('.admin__field'))
    )
  }

  function fieldIsMarkedRequired(fieldEl) {
    if (!fieldEl) return false
    if (fieldEl.classList.contains('required') || fieldEl.classList.contains('_required')) return true
    const lbl = fieldEl.querySelector('label.label, label')
    if (lbl && (lbl.classList.contains('required') || lbl.querySelector('.required'))) return true
    return false
  }

  function controlIsRequired(control, fieldEl) {
    if (!control || control.type === 'hidden') return false
    if (control.getAttribute('aria-required') === 'true') return true
    if (fieldIsMarkedRequired(fieldEl)) return true
    if (control.hasAttribute('required')) return true
    const dv = control.getAttribute('data-validate') || ''
    if (dv.includes('required-entry')) return true
    const vj = control.getAttribute('validation') || ''
    if (/"required"\s*:\s*true/i.test(vj)) return true
    return false
  }

  function isDpoOptionControl(control) {
    const name = control.getAttribute('name') || ''
    if (name.indexOf('options[') === 0) return true
    return !!(control.classList && control.classList.contains('product-custom-option'))
  }

  function dpoRadioIsPlaceholderNone(radio) {
    if (!radio || radio.type !== 'radio' || !radio.checked) return false
    const wrap =
      radio.closest('.admin__field-option') ||
      radio.closest('.field-choice') ||
      radio.parentElement
    if (!wrap || !wrap.querySelector) return false
    const v = String(radio.value || '').trim().toLowerCase()
    if (v === '' || v === 'null') return true
    // Real choice: image/color swatch or explicit data-visualizer value on the option row
    if (wrap.querySelector('.itoris-dynamicoptions-thumbnail-image')) return false
    if (wrap.querySelector('.itoris-dynamicoptions-thumbnail-color:not(.dpo-choice-none)')) return false
    if (Array.from(wrap.classList || []).some(function (c) { return c.indexOf('data-visualizer-value-') === 0 })) {
      return false
    }
    return !!wrap.querySelector('.dpo-choice-none')
  }

  function fieldLooksOptional(fieldEl) {
    if (!fieldEl) return false
    if (fieldEl.classList.contains('optional')) return true
    if (fieldEl.getAttribute('data-required') === 'false') return true
    if (fieldEl.classList.contains('not-required')) return true
    return false
  }

  function sectionHasDpoUnselectedRadioGroup(sectionContainer) {
    if (!sectionContainer) return false
    const seen = new Set()
    const radios = sectionContainer.querySelectorAll('input[type="radio"]')
    for (let i = 0; i < radios.length; i++) {
      const el = radios[i]
      if (!isDpoOptionControl(el)) continue
      if (el.disabled) continue
      const gn = el.name
      if (!gn || seen.has(gn)) continue
      seen.add(gn)
      const group = Array.from(sectionContainer.querySelectorAll('input[type="radio"]')).filter(function (r) {
        return r.name === gn && !r.disabled
      })
      if (group.length === 0) continue
      const fe = dpoFieldWrapperFor(group[0])
      if (!fe || isFieldEffectivelyHidden(fe, sectionContainer)) continue
      if (fieldLooksOptional(fe)) continue
      const req = group.some(function (r) {
        return controlIsRequired(r, dpoFieldWrapperFor(r) || fe)
      })
      if (!req) continue
      const visible = group.filter(function (r) {
        const f = dpoFieldWrapperFor(r)
        return f && !isFieldEffectivelyHidden(f, sectionContainer)
      })
      if (visible.length === 0) continue
      const checked = visible.find(function (r) {
        return r.checked
      })
      if (!checked) return true
      if (dpoRadioIsPlaceholderNone(checked)) return true
    }
    return false
  }

  function sectionHasVisibleValidationDom(container) {
    if (!container) return false
    if (container.querySelector('.validation-advice, .mage-error, .field-error')) return true
    const next = container.nextElementSibling
    if (next && next.classList && next.classList.contains('validation-advice')) return true
    return false
  }

  function sectionHasUnfilledRequired(sectionContainer) {
    if (!sectionContainer) return false
    const radioDone = new Set()
    const checkboxDone = new Set()
    const controls = sectionContainer.querySelectorAll('input, select, textarea')
    for (let i = 0; i < controls.length; i++) {
      const el = controls[i]
      if (!isDpoOptionControl(el)) continue
      if (el.type === 'hidden') continue
      if (el.classList && el.classList.contains('dpo-slider-value')) continue
      if (el.disabled) continue
      const field = dpoFieldWrapperFor(el)
      if (!field || isFieldEffectivelyHidden(field, sectionContainer)) continue

      if (el.type === 'radio') {
        const gn = el.name
        if (!gn || radioDone.has(gn)) continue
        const group = Array.from(sectionContainer.querySelectorAll('input[type="radio"]')).filter(function (r) {
          return r.name === gn && !r.disabled
        })
        if (group.length === 0) continue
        const fe = dpoFieldWrapperFor(group[0])
        if (!fe || isFieldEffectivelyHidden(fe, sectionContainer)) continue
        const req = group.some(function (r) {
          return controlIsRequired(r, dpoFieldWrapperFor(r) || fe)
        })
        radioDone.add(gn)
        if (!req) continue
        const checkedRadio = group.find(function (r) {
          return r.checked
        })
        if (!checkedRadio) return true
        if (dpoRadioIsPlaceholderNone(checkedRadio)) return true
        continue
      }

      if (el.type === 'checkbox') {
        const gn = el.name
        if (!gn || checkboxDone.has(gn)) continue
        const group = Array.from(sectionContainer.querySelectorAll('input[type="checkbox"]')).filter(function (c) {
          return c.name === gn && !c.disabled
        })
        if (group.length === 0) continue
        const fe = dpoFieldWrapperFor(group[0])
        if (!fe || isFieldEffectivelyHidden(fe, sectionContainer)) continue
        const req = group.some(function (c) {
          return controlIsRequired(c, dpoFieldWrapperFor(c) || fe)
        })
        if (!req) continue
        checkboxDone.add(gn)
        if (!group.some(function (c) { return c.checked })) return true
        continue
      }

      if (!controlIsRequired(el, field)) continue

      if (el.type === 'file') {
        if (!el.files || el.files.length === 0) return true
        continue
      }

      if (el.tagName === 'SELECT') {
        if (el.multiple) {
          if (!el.selectedOptions || el.selectedOptions.length === 0) return true
        } else {
          if (!String(el.value || '').trim()) return true
        }
        continue
      }

      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        if (!String(el.value || '').trim()) return true
      }
    }
    return false
  }

  function sectionHasHeuristicValidationIssue(container) {
    return (
      sectionHasUnfilledRequired(container) ||
      sectionHasNativeInvalidControls(container) ||
      sectionHasDpoUnselectedRadioGroup(container)
    )
  }

  function forceSectionDomVisible(sec) {
    if (!sec || !sec.container) return
    const panel = sec.container
    const header = sec.header
    if (header) header.classList.remove('ihidden', 'hidden')
    panel.classList.remove('ihidden', 'hidden')
    try {
      panel.style.removeProperty('width')
      panel.style.removeProperty('height')
      panel.style.removeProperty('overflow')
      panel.style.removeProperty('visibility')
      panel.style.removeProperty('display')
    } catch (e) {}
    const controls = panel.querySelectorAll('.product-custom-option, textarea.product-custom-option, select.product-custom-option')
    controls.forEach((input) => {
      const field = input.closest('.field')
      if (field && isFieldEffectivelyHidden(field, panel)) return
      if (input.disabled) input.disabled = false
    })
  }

  function hasHiddenAncestor(el) {
    const root = document.getElementById('itoris_dynamicproductoptions')
    let node = el && el.parentElement
    while (node && node !== root) {
      if (elementIsDpoHidden(node)) return true
      node = node.parentElement
    }
    return false
  }

  function hasEnabledVisibleOption(container) {
    if (!container) return false
    const opts = container.querySelectorAll('.product-custom-option')
    for (let i = 0; i < opts.length; i++) {
      const el = opts[i]
      if (el.disabled) continue
      const field = el.closest('.field')
      if (field) {
        if (field.classList.contains('ihidden')) continue
        const st = field.getAttribute('style') || ''
        if (/display\s*:\s*none/i.test(st)) continue
        const tr = field.closest('tr.fields')
        if (tr) {
          const ts = tr.getAttribute('style') || ''
          if (/display\s*:\s*none/i.test(ts)) continue
        }
      }
      return true
    }
    return false
  }

  function sectionIsSuppressedByDpoShell(container) {
    if (!container) return true
    if (container.classList.contains('ihidden')) return true
    if (container.classList.contains('hidden')) return true
    const attrStyle = container.getAttribute('style') || ''
    if (/display\s*:\s*none/i.test(attrStyle)) return true
    if (/visibility\s*:\s*hidden/i.test(attrStyle)) return true
    if (/height\s*:\s*0(?:px)?/i.test(attrStyle) && /\bwidth\s*:\s*0(?:px)?/i.test(attrStyle)) return true
    return false
  }

  function computeSectionSuppressed(container) {
    if (sectionIsSuppressedByDpoShell(container)) return true
    if (container.querySelector('.product-custom-option') && !hasEnabledVisibleOption(container)) return true
    return false
  }

  function setupDpoSuppressionObserver(root) {
    if (!root || root.__dpoSuppressionObserved) return
    let debounceTimer
    let trailingTimer
    const runRefresh = () => {
      if (typeof root.__dpoRefreshSuppression === 'function') root.__dpoRefreshSuppression()
    }
    const schedule = () => {
      clearTimeout(debounceTimer)
      clearTimeout(trailingTimer)
      debounceTimer = setTimeout(() => {
        runRefresh()
        try {
          if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(runRefresh)
          }
        } catch (e) {}
        trailingTimer = setTimeout(runRefresh, 180)
      }, 60)
    }
    const observer = new MutationObserver(schedule)
    observer.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'disabled', 'hidden'],
      childList: true
    })
    root.addEventListener('input', schedule, { passive: true, capture: true })
    root.addEventListener('change', schedule, { passive: true, capture: true })
    root.__dpoSuppressionObserved = true
  }

  // DPO "next step" / mobile wizard collapses sections with inline height/overflow/width; strip when we show a tab/panel.
  function stripDpoStepCollapseInline(panel) {
    if (!panel) return
    try {
      ['height', 'max-height', 'min-height', 'overflow', 'width', 'visibility'].forEach(function (p) {
        panel.style.removeProperty(p)
      })
    } catch (e) {}
  }

  // Visually hide a panel without removing it from DOM (keeps DPO inputs alive).
  function setPanelVisibility(panel, visible){
    if (!panel) return
    if (visible) {
      panel.classList.remove(TAB_HIDDEN_CLASS)
      panel.classList.remove(OFFSCREEN_HIDDEN_CLASS)
      panel.removeAttribute('hidden')
      panel.setAttribute('aria-hidden','false')
      stripDpoStepCollapseInline(panel)
      try {
        if (!sectionIsSuppressedByDpoShell(panel)) panel.style.removeProperty('display')
      } catch (e) { /* noop */ }
    } else {
      panel.classList.add(OFFSCREEN_HIDDEN_CLASS)
      panel.classList.add(TAB_HIDDEN_CLASS)
      // Keep in DOM; rely on CSS to move it off-screen instead of display:none
      panel.removeAttribute('hidden')
      panel.setAttribute('aria-hidden','true')
      try { panel.style.removeProperty('display') } catch(e) { panel.style.display = '' }
    }
  }

  function buildTabs(){
    const root = document.getElementById('itoris_dynamicproductoptions')
    if (!root) return false
    if (root.__dpoTabbed) return true

    // Remove accordion if present
    const oldAccordion = root.querySelectorAll('.dpo-accordion__item')
    oldAccordion.forEach(el => el.remove())
    
    // Reset accordion flag
    root.__dpoAccordion = false

    const headers = Array.from(root.querySelectorAll('h2.legend'))
    if (headers.length === 0) return false

    const sections = []
    headers.forEach(h => {
      let cont = h.nextElementSibling
      if (!cont || !cont.classList || !cont.classList.contains('fieldset-section')) {
        const forId = h.getAttribute('for')
        if (forId) cont = root.querySelector('#' + CSS.escape(forId))
      }
      if (cont && cont.classList.contains('fieldset-section')) {
        const title = h.textContent.trim()
        if (isHiddenTitle(title)) {
          hardHideSection(h, cont)
          return
        }
        const key = titleToKey(title)
        sections.push({header:h, container:cont, title, key})
      }
    })
    if (sections.length === 0) return false

    // Create tab bar
    const bar = document.createElement('div')
    bar.className = TABBAR_CLASS
    bar.setAttribute('role','tablist')

    // Insert tab bar before first section header
    const first = sections[0]
    root.insertBefore(bar, first.header)

    sections.forEach((sec, idx) => {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = TABBTN_CLASS
      btn.setAttribute('role','tab')
      btn.setAttribute('aria-controls', sec.container.id || '')
      btn.dataset.dpoTabKey = sec.key
      btn.addEventListener('click', () => activate(idx, true))
      const labelSpan = document.createElement('span')
      labelSpan.className = 'dpo-tabs__btn-label'
      labelSpan.textContent = sec.title
      btn.appendChild(labelSpan)
      btn.appendChild(createStateIndicator())
      bar.appendChild(btn)

      // Clean up accordion classes and attributes
      sec.container.classList.remove(PANEL_CLASS, PANEL_HIDDEN_CLASS)
      sec.container.removeAttribute('aria-labelledby')
      sec.container.setAttribute('role','tabpanel')
      sec.header.style.display = 'none'
    })

    function applyDpoSuppressionTabs() {
      const activeIdx = Array.from(bar.children).findIndex(b => b.classList.contains(TABBTN_ACTIVE))
      const isTabSuppressed = (sec) => {
        const shouldBeVisible = sectionShouldBeVisibleByConfig(sec.container)
        if (shouldBeVisible === true) {
          forceSectionDomVisible(sec)
          return false
        }
        return computeSectionSuppressed(sec.container)
      }
      sections.forEach((sec, idx) => {
        const btn = bar.children[idx]
        if (!btn) return
        const suppressed = isTabSuppressed(sec)
        if (suppressed) {
          btn.classList.add(TAB_DPO_HIDDEN_CLASS)
          btn.setAttribute('hidden', '')
          btn.setAttribute('tabindex', '-1')
          setPanelVisibility(sec.container, false)
        } else {
          btn.classList.remove(TAB_DPO_HIDDEN_CLASS)
          btn.removeAttribute('hidden')
          const shouldShow = SHOW_ALL_SECTIONS || (activeIdx >= 0 && idx === activeIdx)
          btn.setAttribute('tabindex', shouldShow ? '0' : '-1')
          setPanelVisibility(sec.container, shouldShow)
        }
      })
    }

    function refreshDpoSuppressionTabs() {
      const activeIdx = Array.from(bar.children).findIndex(b => b.classList.contains(TABBTN_ACTIVE))
      const isTabSuppressed = (sec) => {
        const shouldBeVisible = sectionShouldBeVisibleByConfig(sec.container)
        if (shouldBeVisible === true) {
          forceSectionDomVisible(sec)
          return false
        }
        return computeSectionSuppressed(sec.container)
      }
      const suppressedBefore = sections.map((sec, idx) => {
        const btn = bar.children[idx]
        if (!btn) return true
        return btn.classList.contains(TAB_DPO_HIDDEN_CLASS) || btn.hasAttribute('hidden')
      })
      applyDpoSuppressionTabs()
      const newlyVisible = sections
        .map((sec, idx) => ({ idx, btn: bar.children[idx] }))
        .filter(({ idx, btn }) => btn && suppressedBefore[idx] && !btn.classList.contains(TAB_DPO_HIDDEN_CLASS) && !btn.hasAttribute('hidden'))

      if (activeIdx >= 0 && sections[activeIdx] && isTabSuppressed(sections[activeIdx])) {
        const next = sections.findIndex(s => !isTabSuppressed(s))
        if (next >= 0) activate(next, false)
        else sections.forEach(sec => setPanelVisibility(sec.container, false))
      } else if (activeIdx < 0) {
        const next = sections.findIndex(s => !isTabSuppressed(s))
        if (next >= 0) activate(next, false)
      }

      if (isMobile() && newlyVisible.length) {
        const firstVisibleBtn = newlyVisible[0].btn
        try {
          requestAnimationFrame(() => {
            if (!firstVisibleBtn || firstVisibleBtn.hasAttribute('hidden')) return
            firstVisibleBtn.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            })
          })
        } catch (e) {}
      }
      updateSectionStates(root)
    }

    function dispatchChange(sec){
      try {
        const wrapper = document.getElementById('itoris_dynamicproductoptions')
        if (wrapper) {
          wrapper.dispatchEvent(new CustomEvent('change-tab', { detail: { tab: sec.key }, bubbles: true }))
        }
      } catch(e){}
    }

    function activate(index, fromUser){
      if (!sections[index]) return
      const shouldBeVisible = sectionShouldBeVisibleByConfig(sections[index].container)
      if (shouldBeVisible === true) {
        forceSectionDomVisible(sections[index])
      } else if (computeSectionSuppressed(sections[index].container)) return

      let prevActive = -1
      for (let pi = 0; pi < bar.children.length; pi++) {
        if (bar.children[pi].classList.contains(TABBTN_ACTIVE)) {
          prevActive = pi
          break
        }
      }
      if (fromUser && prevActive >= 0 && prevActive !== index && sections[prevActive]) {
        markSectionClosed(root, prevActive)
        scheduleSectionValidationAfterClose(root, sections[prevActive].container)
      }

      sections.forEach((sec, i) => {
        const active = i === index
        const visible = SHOW_ALL_SECTIONS || active
        const btn = bar.children[i]
        if (btn) {
          btn.classList.toggle(TABBTN_ACTIVE, active)
          btn.setAttribute('aria-selected', active ? 'true' : 'false')
          btn.setAttribute('tabindex', active ? '0' : '-1')
        }
        if (visible) {
          setPanelVisibility(sec.container, true)
        } else if (!SHOW_ALL_SECTIONS) {
          setPanelVisibility(sec.container, false)
        }
      })
      
      // Scroll active tab into view on mobile
      if (fromUser && isMobile()) {
        const activeBtn = bar.children[index]
        if (activeBtn) {
          activeBtn.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          })
        }
      }
      
      if (fromUser) dispatchChange(sections[index])
      updateSectionStates(root)

      if (isMobile()) {
        const shown = sections[index].container
        const beatDpo = function () {
          const shownSec = sections[index]
          if (!shownSec || !shown) return
          const shouldBeVisible = sectionShouldBeVisibleByConfig(shown)
          if (shouldBeVisible === true) {
            forceSectionDomVisible(shownSec)
          } else if (computeSectionSuppressed(shown)) return
          stripDpoStepCollapseInline(shown)
        }
        beatDpo()
        requestAnimationFrame(function () {
          beatDpo()
          requestAnimationFrame(beatDpo)
        })
      }
    }

    applyDpoSuppressionTabs()
    root.__dpoRefreshSuppression = refreshDpoSuppressionTabs
    setupDpoSuppressionObserver(root)

    let initial = -1
    for (let i = 0; i < sections.length; i++) {
      const shouldBeVisible = sectionShouldBeVisibleByConfig(sections[i].container)
      if (shouldBeVisible === true) {
        forceSectionDomVisible(sections[i])
        initial = i
        break
      }
      if (!computeSectionSuppressed(sections[i].container)) { initial = i; break }
    }
    if (initial >= 0) activate(initial, false)
    else sections.forEach(sec => setPanelVisibility(sec.container, false))
    
    // Scroll to initial tab on mobile after a short delay to ensure layout is ready
    if (isMobile() && initial >= 0) {
      setTimeout(() => {
        const initialBtn = bar.children[initial]
        if (initialBtn) {
          initialBtn.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          })
        }
      }, 100)
    }

    root.__dpoTabbed = true
    setupStateObserver(root)
    updateSectionStates(root)
    setTimeout(() => updateSectionStates(root), 300)
    return true
  }

  function buildAccordion(){
    const root = document.getElementById('itoris_dynamicproductoptions')
    if (!root) return false
    if (root.__dpoAccordion) return true

    // Remove tab bar if present
    const oldBar = root.querySelector('.dpo-tabs__bar')
    if (oldBar) oldBar.remove()
    
    // Reset tabs flag
    root.__dpoTabbed = false

    const headers = Array.from(root.querySelectorAll('h2.legend'))
    if (headers.length === 0) return false

    const sections = []
    headers.forEach((h, idx) => {
      let cont = h.nextElementSibling
      if (!cont || !cont.classList || !cont.classList.contains('fieldset-section')) {
        const forId = h.getAttribute('for')
        if (forId) cont = root.querySelector('#' + CSS.escape(forId))
      }
      if (cont && cont.classList.contains('fieldset-section')) {
        const title = h.textContent.trim()
        if (isHiddenTitle(title)) {
          hardHideSection(h, cont)
          return
        }
        const key = titleToKey(title)
        sections.push({header:h, container:cont, title, key, index:idx})
      }
    })
    if (sections.length === 0) return false

    // Wrap sections into accordion items
    sections.forEach((sec, idx) => {
      const panelId = sec.container.id || `fieldset-section-${idx+1}`
      sec.container.id = panelId
      const btnId = `dpo-accordion-trigger-${panelId}`

      const item = document.createElement('div')
      item.className = ITEM_CLASS

      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = `${HEADER_CLASS} btn-pill--accent`
      btn.setAttribute('aria-controls', panelId)
      btn.setAttribute('aria-expanded','false')
      btn.id = btnId
      btn.dataset.dpoTabKey = sec.key
      btn.addEventListener('click', () => toggle(idx))

      // Create icon container
      const iconContainer = document.createElement('div')
      iconContainer.className = 'dpo-accordion__icon'
      const iconInner = document.createElement('div')
      iconInner.className = 'dpo-accordion__icon-inner'
      iconContainer.appendChild(iconInner)

      // Create label container
      const labelContainer = document.createElement('div')
      labelContainer.className = 'dpo-accordion__label'
      const labelText = document.createElement('div')
      labelText.className = 'dpo-accordion__label-text'
      labelText.textContent = sec.title
      labelContainer.appendChild(labelText)

      btn.appendChild(iconContainer)
      btn.appendChild(labelContainer)
      btn.appendChild(createStateIndicator())

      sec.container.setAttribute('role','region')
      sec.container.setAttribute('aria-labelledby', btnId)
      sec.container.classList.add(PANEL_CLASS, PANEL_HIDDEN_CLASS)
      sec.container.setAttribute('hidden','')
      sec.container.setAttribute('aria-hidden','true')

      // Hide original header but keep DOM in place for DPO bindings
      sec.header.style.display = 'none'

      // Insert item before the original header to preserve order
      root.insertBefore(item, sec.header)
      item.appendChild(btn)
      item.appendChild(sec.container)

      sec.button = btn
      sec.item = item
    })

    function applyDpoSuppressionAccordion() {
      sections.forEach((sec, idx) => {
        const suppressed = computeSectionSuppressed(sec.container)
        if (!sec.item) return
        if (suppressed) {
          sec.item.classList.add(ITEM_DPO_HIDDEN_CLASS)
          sec.item.setAttribute('hidden', '')
          if (sec.button) {
            sec.button.disabled = true
            sec.button.setAttribute('aria-expanded', 'false')
          }
          setPanelVisibility(sec.container, false)
        } else {
          sec.item.classList.remove(ITEM_DPO_HIDDEN_CLASS)
          sec.item.removeAttribute('hidden')
          if (sec.button) sec.button.disabled = false
          const shouldShow = SHOW_ALL_SECTIONS || (sec.button && sec.button.getAttribute('aria-expanded') === 'true')
          setPanelVisibility(sec.container, shouldShow)
        }
      })
    }

    function refreshDpoSuppressionAccordion() {
      const openIdx = sections.findIndex(s => s.button && s.button.getAttribute('aria-expanded') === 'true')
      applyDpoSuppressionAccordion()
      if (openIdx >= 0 && computeSectionSuppressed(sections[openIdx].container)) {
        setState(sections[openIdx], false, openIdx)
        const next = sections.findIndex(s => !computeSectionSuppressed(s.container))
        if (next >= 0) {
          closeOthers(next)
          setState(sections[next], true, next)
          dispatchChange(sections[next], true)
        }
      }
      updateSectionStates(root)
    }

    function dispatchChange(sec, open){
      try {
        const wrapper = document.getElementById('itoris_dynamicproductoptions')
        if (wrapper) {
          const detail = open !== undefined ? { tab: sec.key, open } : { tab: sec.key }
          wrapper.dispatchEvent(new CustomEvent('change-tab', { detail, bubbles: true }))
        }
      } catch(e){}
    }

    function setState(sec, open, idx){
      if (SHOW_ALL_SECTIONS) open = true
      if (open && sec.item && computeSectionSuppressed(sec.container)) return
      const btn = sec.button
      const panel = sec.container
      if (btn) {
        const wasOpen = btn.getAttribute('aria-expanded') === 'true'
        btn.setAttribute('aria-expanded', open ? 'true' : 'false')
        if (wasOpen && !open && idx !== undefined) markSectionClosed(root, idx)
      }
      setPanelVisibility(panel, open)
    }

    function closeOthers(exceptIdx){
      if (!SINGLE_OPEN || SHOW_ALL_SECTIONS) return
      sections.forEach((sec, i) => {
        if (i !== exceptIdx) {
          const wasOpen = sec.button && sec.button.getAttribute('aria-expanded') === 'true'
          if (wasOpen) {
            markSectionClosed(root, i)
            scheduleSectionValidationAfterClose(root, sec.container)
          }
          setState(sec, false, i)
        }
      })
    }

    function toggle(index){
      const sec = sections[index]
      if (!sec || !sec.button) return
      if (sec.item && sec.item.classList.contains(ITEM_DPO_HIDDEN_CLASS)) return
      const isOpen = sec.button.getAttribute('aria-expanded') === 'true'
      const next = !isOpen
      if (SHOW_ALL_SECTIONS) {
        setState(sec, true)
        dispatchChange(sec, true)
        return
      }
      if (next) closeOthers(index)
      if (!next) {
        markSectionClosed(root, index)
        scheduleSectionValidationAfterClose(root, sec.container)
      }
      setState(sec, next, index)
      dispatchChange(sec, next)
      updateSectionStates(root)
      if (next) scrollAccordionItemIntoView(sec.item || sec.button)
    }

    // Ensure all panels are explicitly initialized first
    sections.forEach(sec => {
      setState(sec, SHOW_ALL_SECTIONS ? true : false)
    })

    applyDpoSuppressionAccordion()
    root.__dpoRefreshSuppression = refreshDpoSuppressionAccordion
    setupDpoSuppressionObserver(root)

    // Desktop requirement: open the first available panel on initial load.
    // Do not override when SHOW_ALL_SECTIONS is enabled.
    if (!SHOW_ALL_SECTIONS && !isMobile() && sections.length) {
      let initial = -1
      for (let i = 0; i < sections.length; i++) {
        if (!computeSectionSuppressed(sections[i].container)) { initial = i; break }
      }
      if (initial >= 0) {
        closeOthers(initial)
        setState(sections[initial], true)
        dispatchChange(sections[initial], true)
      }
    }

    root.__dpoAccordion = true
    setupStateObserver(root)
    updateSectionStates(root)
    setTimeout(() => updateSectionStates(root), 300)
    return true
  }

  function init(){
    // Run when DPO signals ready or on fallback
    if (isMobile()) {
      if (!buildTabs()) {
        setTimeout(buildTabs, 500)
      }
    } else {
      if (!buildAccordion()) {
        setTimeout(buildAccordion, 500)
      }
    }
  }

  function handleResize(){
    const root = document.getElementById('itoris_dynamicproductoptions')
    if (!root) return
    
    if (isMobile()) {
      if (!root.__dpoTabbed) {
        root.__dpoAccordion = false
        init()
      }
    } else {
      if (!root.__dpoAccordion) {
        root.__dpoTabbed = false
        init()
      }
    }
  }

  // Listen for Itoris event if jQuery is present
  try {
    if (window.jQuery && window.jQuery(window) && window.jQuery(window).on) {
      window.jQuery(window).on('dpo_loading_finished', function(){
        // Defer a tick to let DPO finish DOM tweaks
        setTimeout(init, 0)
      })
    }
  } catch(e){}

  document.addEventListener('dpo-update-section-states', function(){
    const root = document.getElementById('itoris_dynamicproductoptions')
    if (root) updateSectionStates(root)
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  // Re-run if DPO re-injects DOM later
  try {
    const mo = new MutationObserver(() => { 
      if (isMobile()) {
        buildTabs()
      } else {
        buildAccordion()
      }
    })
    mo.observe(document.documentElement, { childList:true, subtree:true })
  } catch(e){}

  // Handle window resize to switch between tabs and accordion
  let resizeTimeout
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(handleResize, 250)
  })
})();
